import { render, staticRenderFns } from "./UiMiniCrudCard.vue?vue&type=template&id=8449cd1a&"
import script from "./UiMiniCrudCard.vue?vue&type=script&lang=js&"
export * from "./UiMiniCrudCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports